define("shared/components/shared/modal/section", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object"], function (_exports, _component, _templateFactory, _component2, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div 
    class="
      {{if @hasSecondary "has--secondary"}}
      {{this.primaryClass}}
      "
     ...attributes
    >
    {{#if header}}
      {{component @header}}
    {{/if}}
    {{#if this.closeIcon}}
      <div 
        role="button" 
        aria-label={{t "shared_words.close"}} 
        class="o--modal--closeIcon" 
        {{on "click" @close}}
        {{!-- Using `keyup` event here instead of 'keydown' due to Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1220143 --}}
        {{on "keyup" this.handleKeyUp}}
      >
        {{svg-jar "close" class="o--icon--md o--icon--white" tabIndex=0}}
      </div>
    {{/if}}
    {{yield}}
  </div>
  
  */
  {
    "id": "KfV4Tppk",
    "block": "[[[11,0],[16,0,[29,[\"\\n    \",[52,[30,1],\"has--secondary\"],\"\\n    \",[30,0,[\"primaryClass\"]],\"\\n    \"]]],[17,2],[12],[1,\"\\n\"],[41,[33,1],[[[1,\"    \"],[46,[30,3],null,null,null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"closeIcon\"]],[[[1,\"    \"],[11,0],[24,\"role\",\"button\"],[16,\"aria-label\",[28,[37,3],[\"shared_words.close\"],null]],[24,0,\"o--modal--closeIcon\"],[4,[38,4],[\"click\",[30,4]],null],[4,[38,4],[\"keyup\",[30,0,[\"handleKeyUp\"]]],null],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"close\"],[[\"class\",\"tabIndex\"],[\"o--icon--md o--icon--white\",0]]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[18,5,null],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@hasSecondary\",\"&attrs\",\"@header\",\"@close\",\"&default\"],false,[\"if\",\"header\",\"component\",\"t\",\"on\",\"svg-jar\",\"yield\"]]",
    "moduleName": "shared/components/shared/modal/section.hbs",
    "isStrictMode": false
  });

  const SPACE_KEY = 32;
  let Section = (_class = class Section extends _component2.default {
    get closable() {
      var _this$args$closable;

      return (_this$args$closable = this.args.closable) !== null && _this$args$closable !== void 0 ? _this$args$closable : true;
    }

    get closeIcon() {
      if (this.args.closeIcon) {
        return this.args.closeIcon;
      }

      return this.args.close && this.closable;
    }

    get primaryClass() {
      if (this.args.primaryClass) {
        return this.args.primaryClass;
      }

      return this.args.portrait ? 'o--modalCard--narrow' : 'o--modalCard';
    } // Using `keyup` event here instead of 'keydown' due to Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1220143


    handleKeyUp(event) {
      const key = event.code || event.keyCode;

      if (key === 'Space' || key === SPACE_KEY) {
        event.preventDefault();
        this.args.close();
      }
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "handleKeyUp", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyUp"), _class.prototype)), _class);
  _exports.default = Section;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, Section);
});